module.exports = __webpack_public_path__ + "img/882-9a0f84.png";